import InventarioList from "./list";
import InventarioCreate from "./create";
import InventarioEdit from "./edit";

export default {
    list : InventarioList,
    create : InventarioCreate, 
    edit : InventarioEdit
}